export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const MARK_NOTIFICATION_READ_REQUEST = "MARK_NOTIFICATION_READ_REQUEST";
export const MARK_NOTIFICATION_READ_SUCCESS = "MARK_NOTIFICATION_READ_SUCCESS";
export const MARK_NOTIFICATION_READ_FAILURE = "MARK_NOTIFICATION_READ_FAILURE";

export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";
export const OPEN_NOTIFICATION_MODAL = "OPEN_NOTIFICATION_MODAL";
export const CLOSE_NOTIFICATION_MODAL = "CLOSE_NOTIFICATION_MODAL";
